module.exports = __webpack_public_path__ + "static/ebr-15-5862f0e6d2f65ca3a8194d51a7c85911.jpg";